import * as api from './resources/rw-captcha.api';
import captchaTemplate from './template.html';

function rwCaptcha() {
  return {
    require: 'ngModel',
    scope: {
      ngModel: '=',
    },
    template: captchaTemplate,
    restrict: 'A',
    link: (scope, elm, attrs, ctrl) => {
      if (!ctrl) {
        // 'Match validation requires ngModel to be on the element'
        return;
      }

      scope.reload = () => {
        scope.ngModel = null;
        const captchaCallback = function (token) {
          scope.ngModel = token;
          scope.$apply();
        };
        api.setCaptcha(captchaCallback);
      };

      // trigger first reload
      scope.reload();
    },
  };
}

export default rwCaptcha;



// WEBPACK FOOTER //
// ./src/modules/utils/rw-captcha/rw-captcha-directive.js